import { createFlamingoProductDisplayApp } from '../../../assets/js/ssrHelpers';

export default function registerCarModelDisplay() {
    document.querySelectorAll('.flamingo-product-display')
        .forEach((component) => {
            if (component.id !== 'flamingoProductDisplay') {
                return;
            }
            let config = window.carModelData;
            if (!config) {
                config = component.dataset;
            }

            const flamingoProductDisplayModule = createFlamingoProductDisplayApp(config);

            flamingoProductDisplayModule.mount(component, true);
        });
}
